import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
// import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// gsap.registerPlugin(ScrollTrigger);

// import { SplitText } from 'gsap/SplitText.js'
// gsap.registerPlugin(SplitText);

//import hoverintent from "hoverintent"


class Cover extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = -1
    this.j = -1


    this.ref = {
      artist: [],
      img: [],
      credits: []
    }

  }

  mount() {

    this.bindedchange = this.change.bind(this)
    this.delayedCall = gsap.delayedCall(5, this.bindedchange)

   this.bindedhigh = this.hghlight.bind(this)
   this.delayedhigh = gsap.delayedCall(1, this.bindedhigh)

    var opts = { 
        interval: 0
    };


    // this.ref.artist.forEach((item, i) => {

    //     item.addEventListener("mouseenter", (e) => {
    //         this.ref.img[i].classList.add('is-active')
    //     })
    //     item.addEventListener("mouseleave", (e) => {
    //         this.ref.img[i].classList.remove('is-active')
    //     })

    // });
}

  change() {
    
    const image = gsap.utils.wrap(0, this.ref.img.length, ++this.i)
    
    $('.cover-selected').removeClass('cover-selected')
    this.ref.img[image].classList.add('cover-selected')
    //this.ref.credits[image].classList.add('cover-selected')
    

    this.delayedCall = gsap.delayedCall(5, this.bindedchange)

  }

  hghlight(){
    const artist = gsap.utils.wrap(0, this.ref.artist.length, ++this.j)

    $('.is-highlighted').removeClass('is-highlighted')
    this.ref.artist && this.ref.artist[artist].classList.add('is-highlighted')
    this.delayedhigh = gsap.delayedCall(1, this.bindedhigh)
  }

  unmount() {




  }


}

module.exports = Cover
